import Hideable from '../classes/hideable';
const axios = require('axios');
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

var preventRedirect = true;

/**
 * Initialization product form.
 */
export default function InitProductForm() {
    const productForm = document.getElementById('product-form');

    if(!productForm)
        return;

    const searchParams = new URLSearchParams(window.location.search);
    const openAccessID = searchParams.get('oaid');

    const buttonNext = document.querySelector('.button-next');
    const oaid = productForm.querySelector('input[name="open_access_id"]');
    const fieldStreet = productForm.querySelector('input[name="street"]');
    const fieldNr = productForm.querySelector('input[name="nr"]');
    const fieldZip = productForm.querySelector('input[name="zip"]');
    const fieldCity = productForm.querySelector('input[name="city"]');
    
    buttonNext.addEventListener('click', (event) => {
        event.preventDefault();
        submitForm(productForm, true);
    });

    initModal(productForm);
    highlightField(fieldStreet);
    highlightField(fieldNr);
    highlightField(fieldZip);
    highlightField(fieldCity);
    highlightField(oaid);
    oaid.setAttribute('readonly', true);
    oaid.value = openAccessID;

    pullAddress(openAccessID, (address) => {
        if(!address)
            return;

        if(!fieldStreet.value)
            fieldStreet.value = address.street;
        if(!fieldNr.value)
            fieldNr.value = address.hnr;
        if(!fieldZip.value)
            fieldZip.value = address.zip;
        if(!fieldCity.value)
            fieldCity.value = address.city;
    });
}

function initModal(productForm) {
    const modal = document.querySelector('.modal-check-data');
    const buttonClose = modal.querySelector('.button-modal-close');
    const buttonSubmit = modal.querySelector('.button-modal-submit');
    
    var modalHidable = new Hideable(modal, true);
    modal.classList.remove('hidden');

    window.addEventListener('form-success', (event) => {
        if(event.detail.formHandle !== 'product_form')
            return;

        if(preventRedirect)
            event.preventDefault();
        modalHidable.show();
    });

    buttonClose.addEventListener('click', (event) => {
        event.preventDefault();
        modalHidable.hide();
    });
    buttonSubmit.addEventListener('click', (event) => {
        event.preventDefault();
        submitForm(productForm, false);
    });
}

function submitForm(form, suppressEmail) {
    preventRedirect = suppressEmail;
    const inputSuppressEmail = form.querySelector('input[name="suppress_email"]');
    inputSuppressEmail.setAttribute('value', suppressEmail);

    form.dispatchEvent(new Event('submit'));
}

function pullAddress(openAccessID, callback) {
    axios.get('/address/' + openAccessID)
        .then((response) => {
            if(typeof callback === 'function')
                callback(response.data);
        })
        .catch((error) => {
            if(typeof callback === 'function')
                callback(null);
        });
}

function highlightField(field) {
    field.classList.add('pre-filled');
}